module.exports = __webpack_public_path__ + "static/img/wordbtn.c1a9d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wordbtn.png
// module id = rHK2
// module chunks = 60